import Service from "../../../service/api"
import { data } from "jquery";
import store from "@/store/store";


const Overview = {
    state: {
        getDataCourses: "",
        dataCourse: [],
        setComment: "",
        courseObjectId: "",
        courseCode: "",
        userID: "",
        posted: false,
        allComent: [],
        userCourse: [],
        banners: [],
    },
    mutations: {
        dataCourse(state, res) {
            state.courseCode = res.courseCode;
            state.courseObjectId = res.objectId;
        },
        dataCourseForDisplay(state, res) {
            state.dataCourse = res
        },
        dataComment(state, res) {
            state.allComent = res;
        },
        createComment(state, res) {
            state.setComment = res
        },
        setPosted(state, res) {
            state.posted = res
        },
        setUserCourseOverview(state, res) {
            state.userCourse = res
        },
        setBanner(state, res) {
            state.banners = res
        }
    },
    actions: {
        fetchCoursesOverview({ commit }, courseCode) {
            let coursePayload = {
                courseId: courseCode,
                loginStatus: store.getters["auth/userStatus"] ? true : false
            }
            Service.fetchCoursesOverviewLogin(coursePayload).then((res) => {
                console.log(res.data)
                commit('dataCourseForDisplay', res.data)
            }).catch(err => console.log(err))
        },
        getComment({ commit }, courseObjectId) {
            Service.getComment(courseObjectId).then((res) => {
                commit('dataComment', res.data.courseObject)
            }).catch(err => console.log(err))
        },
        postComment({ commit }, comment) {
            commit('setPosted', false)
            Service.setComment(comment).then((res) => {
                commit('setPosted', true)
            }).catch(err => console.log(err))

        },
        fetchBanner({ commit }) {
            Service.getBanner().then((res) => {
                commit('setBanner', res.data.data)
            }).catch(err => console.log(err))
        },
        addViewer({ commit }, body) {
            Service.addCourseViewer(body).then((res) => {
            }).catch(err => console.log(err))
        }
    },
    getters: {
        getdataCourse(state) {
            return state.dataCourse
        },
        getCourseCode(state) {
            return state.courseCode
        },
        getCourseObjectId(state) {
            return state.courseObjectId
        },
        getDataComment(state) {
            return state.allComent.reverse()
        },
        getCommentPosted(state) {
            return state.posted
        },
        getUserCourseOverview(state) {
            return state.userCourse
        },
        getBanners(state) {
            return state.banners
        }
    }
}

export default Overview;